export default __webpack_public_path__ + "static/media/profile.75d53904.jpg";